import { useMemo } from 'react';
import { useTripStatusAnalysisStore } from '../../stores/analysis/useTripStatusAnalysisStore';
import { getTripKey } from '../../utils/tripAnalysis';
import resolveTripStatus from '../../utils/tripStatus';

export function useTripStatusAnalysis(
    date,
    codigo,
    finalPrev =  null
) {

    const key = useMemo(() => {

        if (!date || !codigo) {
            return null;
        }

        return getTripKey(
            date,
            codigo
        );

    }, [date, codigo]);

    const status = useTripStatusAnalysisStore(
        state => {

            if (!key) {
                return null;
            }

            return (
                state.statusMap.get(key) ||
                null
            );
        }
    );

    return useMemo(() => {

        if (!key) {
            return null;
        }

        return resolveTripStatus(
            status,
            finalPrev
        );

    }, [
        key,
        status,
        finalPrev
    ]);

}